export default __webpack_public_path__ + "static/media/Features-Workforce.94562c9a.svg";